var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"small","disabled":_vm.disabled},on:{"click":_vm.toggleState}},[_c('span',{staticClass:"icon-wrapper"},[(_vm.isInbound)?_c('i',{staticClass:"fas fa-arrow-left"}):_c('i',{staticClass:"fas fa-arrows-alt-h"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }